"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownCircle = _interopRequireDefault(require("./IconArrowDownCircle"));
var IconArrowLeftCircle = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownCircle.default).withConfig({
  displayName: "IconArrowLeftCircle",
  componentId: "c11n-8-107-0__sc-lv8gxv-0"
})(["transform:rotate(90deg);"]);
var _default = IconArrowLeftCircle;
exports.default = _default;